export default {
    online_only: 5.49,
    print_online: 7.95,
    print_online_2: 29.95
}
